export const RECEIVE_ACTIVITIES = 'EDUCATOR/RECEIVE_ACTIVITIES';
